import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import AnalyticsConsent from "@/components/AnalyticsConsent";
import AnalyticsPageView from "@/components/AnalyticsPageView";
import OneSignalManager from "@/components/OneSignalManager";
import PwaLaunchSplash from "@/components/PwaLaunchSplash";
import { AuthProvider, RequireRole } from "@/lib/auth";
import { LanguageProvider } from "@/lib/language";
import Landing from "@/pages/Landing";
import Register from "@/pages/Register";
import ParticipantLayout from "@/pages/participant/Layout";
import Home from "@/pages/participant/Dashboard";
import History from "@/pages/participant/History";
import LeaderboardPage from "@/pages/participant/LeaderboardPage";
import Profile from "@/pages/participant/Profile";
import KeeperApp from "@/pages/keeper/KeeperApp";
import AdminLayout from "@/pages/admin/AdminLayout";
import Overview from "@/pages/admin/Overview";
import Events from "@/pages/admin/Events";
import EventDetail from "@/pages/admin/EventDetail";
import RoutesAdmin from "@/pages/admin/RoutesAdmin";
import Participants from "@/pages/admin/Participants";
import LeadPage from "@/pages/admin/LeadPage";
import Attendance from "@/pages/admin/Attendance";
import Analytics from "@/pages/admin/Analytics";
import AdminLeaderboard from "@/pages/admin/AdminLeaderboard";
import Donation from "@/pages/admin/Donation";
import Staff from "@/pages/admin/Staff";
import Audit from "@/pages/admin/Audit";
import FeedAdmin from "@/pages/admin/FeedAdmin";
import SettingsPage from "@/pages/admin/SettingsPage";

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <AuthProvider>
          <OneSignalManager>
            <PwaLaunchSplash />
            <BrowserRouter>
            <AnalyticsPageView />
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/daftar" element={<Register />} />
              <Route
                path="/app"
                element={
                  <RequireRole roles={["participant"]}>
                    <ParticipantLayout />
                  </RequireRole>
                }
              >
                <Route index element={<Home />} />
                <Route path="riwayat" element={<History />} />
                <Route path="leaderboard" element={<LeaderboardPage />} />
                <Route path="profil" element={<Profile />} />
              </Route>
              <Route
                path="/keeper"
                element={
                  <RequireRole roles={["keeper", "admin"]}>
                    <KeeperApp />
                  </RequireRole>
                }
              />
              <Route
                path="/admin"
                element={
                  <RequireRole roles={["admin"]}>
                    <AdminLayout />
                  </RequireRole>
                }
              >
                <Route index element={<Overview />} />
                <Route path="events" element={<Events />} />
                <Route path="events/:id" element={<EventDetail />} />
                <Route path="routes" element={<RoutesAdmin />} />
                <Route path="participants" element={<Participants />} />
                <Route path="feed" element={<FeedAdmin />} />
                <Route path="lead" element={<LeadPage />} />
                <Route path="attendance" element={<Attendance />} />
                <Route path="analytics" element={<Analytics />} />
                <Route path="leaderboard" element={<AdminLeaderboard />} />
                <Route path="donation" element={<Donation />} />
                <Route path="staff" element={<Staff />} />
                <Route path="audit" element={<Audit />} />
                <Route path="settings" element={<SettingsPage />} />
              </Route>
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
            <AnalyticsConsent />
            </BrowserRouter>
          </OneSignalManager>
          <Toaster position="top-center" richColors />
        </AuthProvider>
      </LanguageProvider>
    </div>
  );
}

export default App;
